module.exports = __webpack_public_path__ + "static/media/student13.26d52621.png";